class Device {
  count = 0;
  data = {
    t: [] as DTouch[],
  };

  handleTouch = (evt: TouchEvent) => {
    // this.count++;
    // if (this.count % 5 !== 0) {
    //   return;
    // }
    const touches: DTouch[] = [];
    for (let i = 0; i < evt.touches.length; i++) {
      const touch = evt.touches[i];
      touches.push({
        x: touch.clientX,
        y: touch.clientY,
        force: touch.force,
        time: Date.now(),
      });
    }
    this.collectTouch(touches);
  };

  mount = () => {
    this.reset();
    document.addEventListener('touchstart', this.handleTouch);
    document.addEventListener('touchmove', this.handleTouch);
  };

  unmount = () => {
    document.removeEventListener('touchstart', this.handleTouch);
    document.removeEventListener('touchmove', this.handleTouch);
  };

  collectTouch = (touches: DTouch[]) => {
    Array.prototype.push.apply(this.data.t, touches);
  };

  getData = () => {
    return this.data;
  };

  reset = () => {
    this.data = {
      t: [] as DTouch[],
    };
  };
}

export default new Device();
